import { login } from 'store/actions/auth-action';
import { AppDispatch, RootState } from 'store/store';
import { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

export default () => {
  const navigate = useNavigate();
  const dispatch: AppDispatch = useDispatch();

  const { auth_loading } = useSelector((state: RootState) => state.auth);
  const { user } = useSelector((state: RootState) => state.common);

  useEffect(() => {
    if (user) navigate('/');
  }, []);

  const passwordRef = useRef<HTMLInputElement>(null);

  const handleLogin = (values: LoginSchema) => {
    const api_data = {
      email: values?.email,
      password: values?.password,
      role: 'Admin',
    };

    dispatch(
      login(api_data, () => {
        navigate('/');
      }),
    );
  };

  return { handleLogin, auth_loading, passwordRef };
};
